module.exports = __webpack_public_path__ + "h5/img/cny.e9553021.png";